import React from 'react'
import tw from 'tailwind-styled-components'

const TwMeta = tw.div`
  w-full
  ml-8
`

export interface Props {
  children?: React.ReactNode
}

export const Meta = (props: Props) => {
  const {children} = props
  return <TwMeta>{children}</TwMeta>
}
